import React from 'react';
import { Text, Flex, Image, useTheme, Progress } from '@pega/cosmos-react-core';
import * as Logos from '../../constants/images';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { InteractiveText } from './custom.styled';
import { updateBannerInfo, updateLoaderDetails, updateSessionDetails } from '../../redux/actions';
import { deleteSession } from '../SocialMedia/Home/SessionApis';
import { appState } from '../../interfaces/common';
import useLocalTranslation from '../../hooks/useLocalTranslation';

type HeaderProps = {
  hideLogout?: boolean;
};
const Header: React.FC<HeaderProps> = (props) => {
  const { hideLogout = false } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const translate = useLocalTranslation();
  const { sessionId, isLoading, noofAsyncCalls, accounts } = useSelector((state: appState) => state);
  const isTwitterConnectionPresent: boolean = accounts.some((account) => ['twitter'].includes(account.platform));
  let shouldShowTwitterBanner = sessionStorage.getItem('shouldShowTwitterBanner');
  if (shouldShowTwitterBanner) {
    shouldShowTwitterBanner = JSON.parse(shouldShowTwitterBanner);
  }
  if (isTwitterConnectionPresent && (shouldShowTwitterBanner || shouldShowTwitterBanner === null)) {
    sessionStorage.setItem('shouldShowTwitterBanner', 'true');
  }

  const {
    base: { 'font-size': fontSize, 'font-weight': fontWeight },
  } = useTheme();

  const routeToPath = function (path: string) {
    navigate(path);
  };

  const logout = async function () {
    dispatch(updateLoaderDetails(true));
    const isSuccessful = await deleteSession(sessionId);
    dispatch(updateLoaderDetails(false));
    if (isSuccessful) {
      sessionStorage.removeItem('sessionId');
      dispatch(updateSessionDetails(false, false, false, ''));
      sessionStorage.setItem('shouldShowTwitterBanner', 'true');
      window.close();
    } else {
      dispatch(updateBannerInfo(translate('logout_error_message'), 'urgent'));
    }
  };

  return (
    <>
      <Flex
        style={{
          position: 'sticky',
          top: '0px',
          zIndex: 5999,
          backgroundColor: 'white',
        }}
      >
        <Flex
          container={{
            direction: 'row',
            justify: 'between',
            itemGap: 1,
            alignItems: 'end',
          }}
          style={{ padding: '.5rem 1rem' }}
        >
          <Flex
            className="pointer"
            onClick={() => routeToPath('/')}
            container={{
              justify: 'center',
              itemGap: 1,
              alignItems: 'center',
            }}
          >
            <Image src={Logos.PegaLogo} alt="Pega" className="pega-logo" />
            <Text style={{ fontSize: fontSize[50], fontWeight: fontWeight['bold'] }}>
              {translate('dmm_title_label')}
            </Text>
          </Flex>
          {hideLogout && (
            <InteractiveText className="pointer" onClick={() => logout()}>
              {translate('logout')}
            </InteractiveText>
          )}
        </Flex>
        <hr style={{ backgroundColor: '#D8D8D8', height: '1px', border: 0 }} />
        {isLoading && noofAsyncCalls !== 0 && <Progress placement="global" />}
      </Flex>
    </>
  );
};

export default Header;
